import type { ReactNode } from "react";
import { cn } from "./cn";

type SectionProps = {
  children: ReactNode;
  light?: boolean;
  id?: string;
  className?: string;
  innerClassName?: string;
};

export function Section({
  children,
  light,
  id,
  className,
  innerClassName,
}: SectionProps) {
  return (
    <section
      id={id}
      className={cn(
        "relative py-32 md:py-32 max-md:py-[72px]",
        light ? "bg-paper grain-light" : "bg-bg grain-dark",
        className,
      )}
    >
      <div
        className={cn(
          "mx-auto max-w-[1280px] px-8 max-md:px-5",
          innerClassName,
        )}
      >
        {children}
      </div>
    </section>
  );
}
